import "./App.scss";
import Routing from "./Routing";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function App() {
  return <Routing />;
}

export default App;
